module.exports = __webpack_public_path__ + "static/media/22ESCWA1.6bd47f82.jpg";